// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const EspecIdContext = createContext()
export const EspecNomeContext = createContext()

export const EspecContextProvider = ({ children }) => {
    const [especIdContext, setEspecIdContext] = useState('')
    const [especNomeContext, setEspecNomeContext] = useState('')

    return (
        <EspecIdContext.Provider value={{ especIdContext, setEspecIdContext }}>
            <EspecNomeContext.Provider value={{ especNomeContext, setEspecNomeContext }}>
                {children}
            </EspecNomeContext.Provider>
        </EspecIdContext.Provider>
    )
}